<!-- YaDialogBox：2019-06-22 Vue: ^2.5.0 YuAng-->

<template>
  <el-dialog title="提示" :visible.sync="visible" :width="width"
    :before-close="cancelAction" @opened="openedAction"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :append-to-body="multiLayer" :top="top"
    center :class="className">
    <div slot="title" style="font-size: 16px;color: #262626;font-weight:bold;"><slot name="title"></slot></div>
    <div style="" class="ya-dialog-content" :class="fullContent? 'padding0':''">
      <slot></slot>
    </div>
    <div slot="footer" class="ya-dialog-footer flex flex-e">
      <button v-if="fastClose" class="ts-base-btn ts-primary-btn its-cancel-btn" @click="cancelAction()">
        取消
      </button>
      <!--slot必须是button类型，否则样式会错乱 YuAng-->
      <slot name="btn"></slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
    name: 'YaDialogBox',
    data() {
        return {
            className: 'ya-dialog-box'
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '30%'
        },
        top: {
            type: String,
            default: '10vh'
        },
        fatherAction: {
            type: Function,
            default: null
        },
        fastClose: {
            type: Boolean,
            default: function () {
                return true
            }
        },
        multiLayer: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        fullContent: { // 是否将自带的边距去掉
            type: Boolean,
            default: function () {
                return false
            }
        }
    },
    mounted() {
        this.addClassName()
    },
    methods: {
        cancelAction: function () {
            if (this.fastClose) {
                this.$emit('update:visible', false)
                return
            }
            if (this.fatherAction) {
                this.fatherAction({type: 'close'})
            } else {
                this.$emit('update:visible', false)
            }
        },
        openedAction: function () {
            if (this.fatherAction) {
                this.fatherAction({type: 'opened'})
            }
        },
        addClassName: function () {
            let className = 'ya-dialog-box'
            className += this.fullContent ? ' padding0' : ''
            this.className = className
        }
    }
}
</script>

<style scoped>
  .ya-dialog-box >>> .el-dialog {
    border-radius: 8px;
  }

  .ya-dialog-box >>> .el-dialog__header {
    background-color: white !important;
    padding: 20px !important;
    text-align: left;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    font-weight: 500;
  }

  .ya-dialog-box >>> .el-dialog__title {
    font-size: 16px;
    color: #262626;
    line-height: 15px;
    font-weight: 400;
  }

  .ya-dialog-box >>> .el-dialog__headerbtn {
    top: 16px;
    right: 10px;
    font-weight: bold;
  }

  .ya-dialog-box >>> .el-dialog__close:hover {
    color: #5591fe;
  }

  .ya-dialog-box >>> .el-dialog__footer {
    padding-top: 20px;
  }

  .ya-dialog-footer >>> .el-button--default {
    background-color: #F4F4F4;
  }

  .ya-dialog-box >>> .el-dialog__body {
    padding: 4px
  }

  .ya-dialog-content {
    overflow: auto;
    width: 100%;
    padding: 8px;
    max-height:520px;
    box-sizing: border-box
  }

  .ya-dialog-box.padding0 >>> .el-dialog__body,
  .ya-dialog-content.padding0 {
    padding: 0;
  }

  .ya-dialog-box >>> .ts-base-btn {
    border-radius: 4px;
    height: 32px;
    font-size: 14px;
    margin-left: 10px;
    margin-right: 0;
  }
</style>
